import React from "react";
import * as Icons from "lucide-react";
import { CATEGORIES } from "@/data/constants";

const iconMap = CATEGORIES.reduce((acc, c) => { acc[c.slug] = c.icon; return acc; }, {});

export default function CategoryIcon({ slug, className = "w-6 h-6" }) {
  const name = iconMap[slug] || "Sparkles";
  const Cmp = Icons[name] || Icons.Sparkles;
  return <Cmp className={className} aria-hidden="true" />;
}
